module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-header.9228a1e1.png";